
import { Component } from 'nuxt-property-decorator'
import SeoMetaComponent from '~/components/classes/meta'
import { Convegno } from '~/types/models/Convegno'

@Component
export default class ConvegniPage extends SeoMetaComponent {
  public items: Convegno[] = []
  public pagination: any | null = null

  async fetch() {
    await this.fetchModel(this.$route.query.page || 1)

    this.loadMeta({
      titolo: 'Convegni',
      contenuto:
        'I convegni promossi dagli Associati della Associazione Nazionale IVG',
      slug: 'convegni',
    })
  }

  fetchOnServer() {
    return true
  }

  async fetchModel(page: any = 1) {
    const { data } = await this.$axios.get(
      'convegni?page=' + page + '&orderBy[]=data_inizio&orderBy[]=desc'
    )
    this.items = [...data.items]
    this.pagination = { ...data.pagination }
  }

  changePage(page: string) {
    this.$router.push({ query: { page } })
    this.fetchModel(Number(page))
    if (process.client) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  public getImage(item: Convegno) {
    if (!item?.assets?.length) {
      return 'img/project-short.jpg'
    }
    const image = item.assets.find(
      (asset) => asset.assetableField === 'mainImage'
    )
    if (!image) {
      return 'img/project-short.jpg'
    }
    return this.$config.cdnEndpoint + '1024/' + image.originalName
  }
}
